import Index from '@views/assets/home/index.vue';
const assetsPage = [
  {
    path: '/assets',
    name: '公募基金',
    component: Index,
    meta: {
      title: '公募基金',
      singleHead: true,
    },
  },
  {
    path: '/pdfPreview',
    name: '资产报告',
    component: () => import("@views/assets/home/pdfPreview.vue"),
    meta: {
      title: '资产报告',
      singleHead: true,
    },
  },
];
export default assetsPage;
